import React from 'react';
import { JSErrorBoundary } from '@atlassian/jira-error-boundaries/src/ui/js-error-boundary/JSErrorBoundary.tsx';
import Placeholder from '@atlassian/jira-placeholder/src/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';
import type { JSMProjectSummaryHorizontalNav } from './ui/index.tsx';
import { PACKAGE_NAME, TEAM_NAME } from './common/constants.tsx';

const LazyJSMProjectSummaryHorizontalNav = lazyForPaint<typeof JSMProjectSummaryHorizontalNav>(() =>
	import(/* webpackChunkName: "jira-project-summary-horizontal-nav" */ './ui').then(
		({ JSMProjectSummaryHorizontalNav }) => JSMProjectSummaryHorizontalNav,
	),
);

export const AsyncJSMProjectSummaryHorizontalNav = (): React.JSX.Element => (
	<Placeholder name="project-summary-horizontal-nav" fallback={null}>
		<JSErrorBoundary
			id="asyncHorizontalProjectSummaryNav"
			packageName={PACKAGE_NAME}
			fallback="flag"
			teamName={TEAM_NAME}
		>
			<LazyJSMProjectSummaryHorizontalNav />
		</JSErrorBoundary>
	</Placeholder>
);
